// Charts for insights/montel-energy-days-2026.html, rendered as inline SVG.
// Data: the deck's chart workbooks (Forsyt_Montel.pptx, slides 4 and 5), in %.
(function () {
  var DATA = {"capture":{"start":"2018-01","capture":[114.1,105.3,102.4,98.7,100.6,103.0,102.1,101.8,102.0,101.2,104.4,111.4,109.5,99.5,100.0,98.1,97.1,99.3,102.1,99.9,102.0,103.4,109.6,109.3,105.1,105.5,86.9,89.6,95.0,102.7,101.9,100.6,101.4,103.2,106.5,114.6,111.6,98.7,92.0,90.4,91.9,97.5,97.1,97.1,97.7,103.7,100.0,112.8,106.3,99.1,92.9,88.4,92.8,99.3,100.3,95.1,98.4,97.3,97.7,108.4,107.3,94.2,90.7,89.9,82.4,84.1,88.1,85.2,83.6,86.4,99.1,99.8,97.1,95.9,80.7,74.6,62.0,69.1,69.2,70.4,63.5,82.3,95.2,106.1,103.4,89.9,67.2,59.6,45.9,59.6,64.7,52.3,55.0,79.1,81.8,94.0,99.0,73.6,51.7,59.1,43.1,69.4,53.4],"spread":[95.1,61.0,78.5,91.6,94.1,68.8,38.3,43.3,53.8,66.8,77.4,64.5,55.4,52.2,77.5,66.0,62.4,93.7,60.0,65.5,79.9,84.1,65.5,85.8,62.0,94.0,105.4,132.3,112.6,74.1,62.6,69.0,93.7,86.4,73.3,83.3,59.8,77.1,77.7,72.5,96.8,55.9,65.2,87.9,62.6,90.0,58.0,58.2,54.3,59.1,54.8,92.8,48.9,52.3,58.7,52.4,75.5,97.9,77.4,66.9,75.4,48.2,75.6,74.1,99.3,78.7,97.1,90.6,114.2,135.7,97.6,80.4,68.6,86.3,119.8,198.7,209.5,199.3,177.2,156.7,172.7,155.6,75.7,90.4,93.4,66.7,138.0,222.1,318.7,211.5,158.6,171.1,215.4,154.0,113.6,85.1,67.0,176.2,197.4,228.9,210.4,163.6,141.1]},"profiles":{"start":"07-09 00:00","stepMin":15,"pv":[0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.2,0.6,1.2,2.0,3.2,4.5,5.9,7.5,10.1,13.5,17.7,22.8,28.6,34.5,40.3,46.1,51.6,57.0,62.1,67.0,71.3,75.0,78.3,81.1,83.2,85.3,87.3,89.3,91.1,92.9,94.7,96.6,97.8,98.4,98.4,97.7,96.2,94.4,92.3,89.9,86.9,83.7,80.1,76.3,71.7,66.6,61.2,55.2,49.1,43.1,37.3,31.8,26.6,21.7,17.1,12.7,9.1,6.2,3.9,2.2,1.4,0.8,0.3,0.1,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.2,0.6,1.1,1.9,3.1,4.6,6.3,8.2,10.6,13.2,15.9,18.8,22.2,26.0,30.2,34.8,39.4,43.6,47.5,50.9,53.9,56.8,59.6,62.3,65.1,68.1,71.4,74.9,77.4,78.6,78.5,77.2,75.2,73.9,73.2,73.2,73.5,73.4,73.0,72.3,71.1,69.9,68.7,67.4,65.2,62.3,58.4,53.8,48.4,43.0,37.7,32.4,27.3,22.4,17.6,12.9,9.2,6.2,4.0,2.6,2.0,1.5,1.1,0.7,0.4,0.2,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,1.8,5.5,10.9,18.2,25.9,32.2,37.2,40.9,42.3,43.0,42.9,42.0,42.4,44.8,49.4,56.0,62.6,67.3,69.8,70.4,67.8,64.1,59.3,53.4,46.9,40.8,35.1,30.0,27.9,28.6,32.0,38.0,44.3,48.0,49.2,47.9,43.7,39.2,34.5,29.5,24.5,19.8,15.4,11.4,8.3,5.7,3.8,2.6,1.9,1.4,1.0,0.6,0.4,0.2,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.2,0.5,1.0,1.7,2.8,4.1,5.6,7.2,9.6,12.6,16.0,20.0,24.9,30.3,36.1,42.3,48.6,54.4,59.8,64.8,67.4,68.0,66.7,63.4,58.7,54.6,51.1,48.2,47.3,48.1,50.3,54.0,58.0,60.8,62.4,62.7,60.7,57.6,53.3,48.0,43.2,40.2,38.8,39.1,40.5,41.1,41.1,40.3,38.1,35.0,31.1,26.4,21.5,17.0,13.1,9.6,7.2,5.2,3.6,2.5,1.9,1.4,1.0,0.6,0.4,0.2,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.2,0.6,1.1,1.8,2.9,4.2,5.7,7.3,9.9,13.2,17.2,21.9,27.4,32.9,38.4,43.9,49.1,54.0,58.7,63.1,65.6,66.6,65.9,63.5,61.3,60.9,62.3,65.4,68.2,68.7,67.1,63.3,60.2,59.7,62.0,67.1,71.7,72.9,70.9,65.6,58.0,51.3,45.7,41.0,37.7,34.7,32.1,29.9,28.1,26.4,24.8,23.3,21.4,19.0,16.2,13.0,9.8,7.1,5.0,3.4,2.4,1.6,1.0,0.6,0.3,0.2,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.2,0.6,1.1,1.8,3.0,4.2,5.7,7.4,9.9,13.1,17.0,21.7,27.0,32.3,37.7,43.1,48.3,53.2,58.0,62.5,66.6,70.4,74.0,77.3,79.9,82.1,83.8,85.1,85.2,84.7,83.6,81.8,79.9,78.6,78.0,77.8,76.5,73.4,68.5,61.7,55.0,50.2,47.3,46.2,46.3,45.5,44.1,41.8,38.6,35.3,31.8,28.2,24.4,20.5,16.5,12.5,9.1,6.4,4.2,2.7,2.0,1.4,0.9,0.5,0.3,0.2,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.2,0.5,1.1,1.8,2.8,4.1,5.5,7.1,9.7,12.9,16.8,21.4,26.7,32.1,37.3,42.6,47.6,52.4,57.0,61.3,65.3,69.3,73.2,77.1,80.5,83.6,86.2,88.4,88.0,85.3,80.3,73.1,67.2,64.8,65.9,70.5,75.7,78.1,77.6,74.2,67.0,58.8,49.8,39.7,31.8,26.7,24.7,25.6,27.2,26.4,23.3,17.8,11.5,6.8,3.5,1.9,1.7,1.4,1.2,0.9,0.6,0.4,0.2,0.1,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.1,0.4,0.9,1.4,2.4,3.5,4.9,6.5,9.1,12.4,16.6,21.5,26.8,31.6,36.0,39.9,43.4,47.0,50.7,54.4,58.5,62.8,67.4,72.2,76.7,80.6,83.9,86.6,87.7,87.6,86.4,84.1,80.0,75.3,69.9,63.8,56.3,47.9,38.8,28.8,20.1,13.4,8.6,5.8,5.4,5.3,5.6,6.2,7.5,9.2,11.2,13.7,15.1,15.2,13.9,11.3,8.0,5.4,3.4,2.2,1.7,1.2,0.8,0.5,0.3,0.2,0.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0],"discharge":[43.3,43.3,32.5,35.7,38.8,28.0,28.0,28.0,14.0,14.0,14.0,0.0,0.0,0.0,0.0,4.6,4.5,18.2,31.9,26.9,35.8,21.1,6.3,5.4,0.0,6.5,4.1,15.3,12.0,4.9,1.6,0.0,0.0,0.0,2.5,0.0,11.4,0.5,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,24.8,38.9,52.9,56.0,56.0,41.0,41.0,27.0,12.0,27.0,12.0,26.0,41.0,41.0,42.0,42.0,28.0,28.0,28.0,14.0,14.0,0.0,0.0,0.0,0.0,2.9,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,7.7,32.4,28.7,31.3,33.8,36.0,52.5,51.4,50.1,48.7,47.1,45.5,43.6,41.5,39.2,36.6,34.0,28.6,5.7,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,8.9,24.5,39.8,54.5,54.9,55.2,41.4,27.6,13.8,13.9,14.0,28.0,42.0,42.0,42.0,28.0,14.0,0.0,0.0,0.0,14.0,28.0,14.0,14.0,14.0,28.0,56.0,42.0,42.0,42.0,28.0,42.0,28.0,14.0,28.0,14.0,0.0,0.0,0.0,0.0,0.0,0.0,6.1,6.1,20.1,34.1,42.0,56.0,52.9,49.8,35.8,35.8,37.9,39.0,49.9,45.9,41.6,33.9,22.6,6.6,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,10.6,19.5,34.5,48.3,49.6,37.0,11.4,12.1,0.0,0.0,27.5,27.7,41.8,55.9,56.0,56.0,56.0,56.0,42.0,42.0,42.0,28.0,28.0,28.0,14.0,28.0,14.0,14.0,14.0,14.0,14.0,0.0,0.0,0.0,0.0,0.0,0.0,6.4,20.4,20.4,20.4,28.0,16.1,16.1,30.0,16.0,13.6,27.2,26.6,39.7,40.0,39.1,9.7,0.0,0.0,0.0,0.0,0.0,21.9,4.4,0.9,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,12.4,8.6,8.6,23.7,10.5,11.1,12.9,0.0,0.0,0.0,0.0,13.9,28.0,42.0,56.0,56.0,41.0,41.0,41.0,41.0,42.0,42.0,27.0,13.0,13.0,13.0,14.0,14.0,14.0,14.0,28.0,42.0,28.0,14.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,13.7,13.4,13.0,12.4,0.0,0.0,8.1,18.1,16.3,20.9,20.0,19.6,16.5,6.6,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,2.6,18.2,5.7,1.8,0.0,0.0,0.2,1.0,2.1,17.4,5.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,14.0,28.0,42.0,56.0,41.0,41.0,41.0,41.0,42.0,28.0,14.0,0.0,0.0,0.0,0.0,14.0,28.0,42.0,56.0,56.0,56.0,42.0,27.9,13.9,12.6,12.2,25.6,38.7,38.8,51.9,50.5,48.7,46.5,43.9,41.0,38.0,35.0,32.0,26.1,9.4,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,5.6,0.0,0.0,1.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,13.5,14.0,14.0,0.0,0.0,14.0,28.0,56.0,56.0,56.0,41.0,29.7,29.7,29.7,30.7,28.0,28.0,14.0,28.0,28.0,20.7,20.7,20.7,24.8,18.1,18.1,4.1,14.0,28.0,28.0,42.0,28.0,14.0,0.0,0.0,0.0,10.9,38.3,53.7,52.9,52.0,50.6,48.8,46.6,44.1,41.1,10.2,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.7,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.4,0.1,0.0,0.0,0.0,13.2,13.3,27.5,41.7,41.8,55.9,55.9,41.9,28.0,14.0,0.0,14.0,28.0,42.0,56.0,42.0,42.0,27.0,27.0,27.0,27.0,42.0,28.0,28.0,14.0,0.0,14.0,14.0,14.0,14.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,13.9,27.6,41.4,41.0,40.5,26.0,25.3,24.4,16.4,28.5,26.2,37.5,27.1,24.4,8.0,5.8,7.2,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,5.2,6.7,8.0,26.9,13.1,27.3,27.3,27.6,41.7,41.9,55.9,42.0,28.0,28.0,14.0,28.0,42.0,28.0,28.0,13.0,13.0,13.0,13.0,18.7],"charge":[0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-5.6,0.0,0.0,0.0,0.0,0.0,0.0,-1.6,-4.7,-8.6,0.0,-0.3,0.0,0.0,-1.3,-16.9,-18.1,-5.5,-20.6,-19.9,-32.7,-45.2,-43.6,-57.6,-71.6,-74.7,-77.8,-66.9,-66.9,-66.9,-77.8,-75.9,-63.0,-45.9,-45.4,-31.0,-19.0,-33.0,-19.5,-32.7,-43.6,-43.6,-37.0,-29.7,-21.2,-12.3,-9.5,-7.0,-5.1,-3.4,-16.2,-15.2,-14.8,-3.5,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-11.1,-11.1,-11.1,-14.0,-14.0,-28.0,-28.0,-17.1,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-16.6,-38.0,-41.0,-41.0,-41.0,-41.0,-56.0,-56.0,-66.9,-74.8,-85.6,-82.2,-81.6,-73.8,-62.9,-66.3,-52.9,-49.8,-46.7,-28.6,-16.7,-29.4,-37.4,-50.8,-51.8,-42.2,-23.3,-21.2,-27.8,-19.2,-24.0,-21.0,-18.1,-8.6,-5.9,-3.2,-0.6,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-14.0,-14.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-14.0,-28.0,-28.0,-14.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-8.3,-23.5,-42.8,-42.3,-56.5,-67.0,-69.5,-74.8,-65.4,-55.0,-43.6,-56.2,-67.9,-71.0,-74.2,-61.5,-49.8,-46.7,-43.6,-46.7,-53.6,-61.5,-56.4,-49.2,-52.7,-40.7,-41.4,-40.6,-24.3,-14.1,-11.5,-6.2,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-1.1,-0.8,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-19.6,-5.6,-5.6,-5.6,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-16.8,-33.9,-36.1,-24.8,-2.9,0.0,0.0,0.0,-12.2,-29.2,-32.0,-34.6,-40.8,-42.5,-40.6,-50.8,-46.8,-56.4,-68.8,-54.4,-54.8,-42.0,-30.1,-32.3,-33.9,-34.7,-37.2,-39.2,-41.4,-39.0,-39.0,-36.5,-36.5,-30.2,-30.2,-26.8,-26.8,-23.8,-32.2,-45.8,-52.9,-63.2,-40.9,-24.2,-7.7,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-0.8,-0.6,-0.3,-0.2,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-14.0,0.0,0.0,0.0,0.0,0.0,0.0,-0.1,0.0,0.0,0.0,0.0,-2.3,-3.2,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-10.4,-27.3,-30.1,-32.7,-35.1,-36.6,-37.1,-36.7,-35.4,-34.2,-33.9,-34.7,-36.4,-38.0,-38.3,-37.4,-35.3,-33.5,-33.3,-34.5,-37.4,-39.9,-40.6,-39.5,-36.5,-32.3,-28.6,-11.4,-3.7,0.0,0.0,0.0,0.0,-1.7,-14.7,0.0,0.0,0.0,0.0,0.0,-7.2,-19.4,-46.0,-44.8,-29.9,-15.3,-0.9,-0.6,-0.3,-0.2,-0.1,-0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-7.3,-23.8,-37.1,-39.2,-41.2,-43.1,-44.5,-31.7,-32.7,-46.3,-59.5,-86.6,-88.7,-85.3,-74.4,-53.9,-64.7,-64.1,-66.0,-67.6,-64.9,-58.0,-62.4,-60.2,-36.1,-42.7,-28.7,-30.9,-38.5,-10.7,-8.9,-6.7,0.0,-5.0,-2.9,0.0,-5.7,-3.4,-1.5,-2.0,-1.5,-0.5,-0.5,-0.1,-0.5,0.0,0.0,0.0,-0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-0.1,-16.4,-2.7,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-14.6,-23.7,-54.5,-57.2,-43.2,-39.4,-13.6,-2.2,-13.1,-17.0,-32.2,-32.7,-33.2,-59.0,-70.0,-82.3,-84.9,-74.0,-51.6,-42.0,-42.0,-28.0,-28.0,-24.9,-21.8,-28.2,-28.2,-17.3,0.0,-6.8,-20.8,-34.8,-57.4,-54.3,-51.2,-37.2,-21.8,-10.2,0.0,0.0,-0.1,-1.0,-0.9,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-0.0,0.0,-13.0,-13.0,-13.0,-14.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,-8.8,-13.9,-30.0,-35.7,-24.1,-24.1,-28.0,-19.3,-21.5,-22.8,-21.5,-31.9,-44.9,-43.6,-40.5,-40.5,-40.5,-40.5,-54.4,-63.3,-71.1,-77.6,-58.1,-53.2,-49.4,-46.8,-59.2,-59.0,-59.0,-37.6,-38.0,-38.7,-39.6,-48.2,-45.1,-31.9,-18.0,-17.3,-10.6,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0]}};

  var C = {
    pv: "#c98500",
    charge: "#3987e5",
    discharge: "#d55181",
    capture: "#c98500",
    spread: "#3987e5",
    grid: "rgba(255, 255, 255, 0.08)",
    axis: "rgba(255, 255, 255, 0.22)",
    text: "#9fb3d1",
    textStrong: "#ecf2ff",
    surface: "#0e1526",
  };

  var TEXT = {
    "en": {
      "capture": "Capture rate PV (%)",
      "spread": "TB1 / BL (%)",
      "axisCapture": "PV capture ratio",
      "axisSpread": "Spread / Base ratio [%]",
      "pv": "PV output (% of plant max)",
      "discharge": "BESS discharging (+%)",
      "charge": "BESS charging (-%)",
      "axisPower": "Power Output [% of BESS / PV Installed Power]"
    },
    "fr": {
      "capture": "Capture rate PV (%)",
      "spread": "TB1 / BL (%)",
      "axisCapture": "Ratio de capture du PV",
      "axisSpread": "Ratio Spread / Base [%]",
      "pv": "PV output (% of plant max)",
      "discharge": "BESS discharging (+%)",
      "charge": "BESS charging (-%)",
      "axisPower": "Power Output [% of BESS / PV Installed Power]"
    },
    "de": {
      "capture": "Capture rate PV (%)",
      "spread": "TB1 / BL (%)",
      "axisCapture": "Capture Ratio PV",
      "axisSpread": "Verhältnis Spread / Base [%]",
      "pv": "PV output (% of plant max)",
      "discharge": "BESS discharging (+%)",
      "charge": "BESS charging (-%)",
      "axisPower": "Power Output [% of BESS / PV Installed Power]"
    }
  };

  var SVGNS = "http://www.w3.org/2000/svg";

  function lang() {
    var l = window.forsytLang || document.documentElement.lang || "en";
    return TEXT[l] ? l : "en";
  }
  function t(key) {
    return TEXT[lang()][key];
  }
  function locale() {
    return { en: "en-GB", fr: "fr-FR", de: "de-DE" }[lang()];
  }
  function pct(v) {
    return (
      new Intl.NumberFormat(locale(), { maximumFractionDigits: 0 }).format(v) +
      (lang() === "en" ? "%" : " %")
    );
  }
  function el(name, attrs, parent) {
    var node = document.createElementNS(SVGNS, name);
    for (var k in attrs) node.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(node);
    return node;
  }
  function text(parent, x, y, str, attrs) {
    var a = { x: x, y: y, fill: C.text, "font-size": 12 };
    for (var k in attrs || {}) a[k] = attrs[k];
    var node = el("text", a, parent);
    node.textContent = str;
    return node;
  }
  function path(xs, ys) {
    var d = "";
    for (var i = 0; i < xs.length; i++) {
      d += (i ? "L" : "M") + xs[i].toFixed(1) + "," + ys[i].toFixed(1);
    }
    return d;
  }

  // Monthly labels from "YYYY-MM" + index.
  function monthDate(start, i) {
    var y = +start.slice(0, 4);
    var m = +start.slice(5, 7) - 1 + i;
    return new Date(Date.UTC(y + Math.floor(m / 12), m % 12, 1));
  }
  function monthLabel(d) {
    return new Intl.DateTimeFormat(locale(), {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    }).format(d);
  }
  // Quarter-hour labels from "MM-DD HH:MM" + index (illustrative week, no year).
  function profileDate(i) {
    var s = DATA.profiles.start;
    var base = Date.UTC(2026, +s.slice(0, 2) - 1, +s.slice(3, 5));
    return new Date(base + i * DATA.profiles.stepMin * 60000);
  }
  function profileLabel(d, withTime) {
    var opts = { day: "numeric", month: "short", timeZone: "UTC" };
    if (withTime) {
      opts.hour = "2-digit";
      opts.minute = "2-digit";
    }
    return new Intl.DateTimeFormat(locale(), opts).format(d);
  }

  function makeTooltip(host) {
    var tip = document.createElement("div");
    tip.className = "deck-chart-tip";
    tip.hidden = true;
    host.appendChild(tip);
    return tip;
  }
  function fillTooltip(tip, title, rows) {
    tip.textContent = "";
    var h = document.createElement("div");
    h.className = "deck-chart-tip-title";
    h.textContent = title;
    tip.appendChild(h);
    rows.forEach(function (r) {
      var row = document.createElement("div");
      row.className = "deck-chart-tip-row";
      var key = document.createElement("span");
      key.className = "deck-chart-tip-key";
      key.style.background = r.color;
      var val = document.createElement("strong");
      val.textContent = pct(r.value);
      var name = document.createElement("span");
      name.textContent = r.name;
      row.appendChild(key);
      row.appendChild(val);
      row.appendChild(name);
      tip.appendChild(row);
    });
  }
  function placeTooltip(tip, host, px, py) {
    tip.hidden = false;
    var hw = host.clientWidth;
    var tw = tip.offsetWidth;
    var left = px + 14;
    if (left + tw > hw) left = px - tw - 14;
    tip.style.left = Math.max(0, left) + "px";
    tip.style.top = Math.max(0, py - 10) + "px";
  }

  function legend(host, items) {
    var box = document.createElement("div");
    box.className = "deck-chart-legend";
    items.forEach(function (it) {
      var item = document.createElement("span");
      var sw = document.createElement("span");
      sw.className = "deck-chart-swatch" + (it.line ? " is-line" : "");
      sw.style.background = it.color;
      item.appendChild(sw);
      item.appendChild(document.createTextNode(it.name));
      box.appendChild(item);
    });
    host.appendChild(box);
  }

  function axisTitle(svg, x, top, bottom, str, side) {
    var cy = (top + bottom) / 2;
    var node = text(svg, x, cy, str, {
      "text-anchor": "middle",
      "font-size": 11.5,
      transform: "rotate(" + (side === "right" ? 90 : -90) + " " + x + " " + cy + ")",
    });
    return node;
  }

  // Shared crosshair: an overlay rect maps pointer x to the nearest index.
  function crosshair(svg, host, opts) {
    var line = el(
      "line",
      { y1: opts.top, y2: opts.bottom, stroke: C.textStrong, "stroke-opacity": 0.35, "stroke-width": 1, visibility: "hidden" },
      svg,
    );
    var dots = opts.series.map(function (s) {
      return el("circle", { r: 4, fill: s.color, stroke: C.surface, "stroke-width": 2, visibility: "hidden" }, svg);
    });
    var hit = el(
      "rect",
      { x: opts.left, y: opts.top, width: opts.right - opts.left, height: opts.bottom - opts.top, fill: "transparent", tabindex: 0 },
      svg,
    );
    var tip = makeTooltip(host);
    var current = -1;
    function show(i) {
      current = i;
      var x = opts.x(i);
      line.setAttribute("x1", x);
      line.setAttribute("x2", x);
      line.setAttribute("visibility", "visible");
      opts.series.forEach(function (s, k) {
        dots[k].setAttribute("cx", x);
        dots[k].setAttribute("cy", s.y(i));
        dots[k].setAttribute("visibility", s.values[i] === 0 && s.hideZero ? "hidden" : "visible");
      });
      fillTooltip(
        tip,
        opts.label(i),
        opts.series.map(function (s) {
          return { name: s.name, color: s.color, value: s.values[i] };
        }),
      );
      var r = svg.getBoundingClientRect();
      var scale = r.width / opts.width;
      placeTooltip(tip, host, x * scale, opts.top * scale);
    }
    function hide() {
      current = -1;
      line.setAttribute("visibility", "hidden");
      dots.forEach(function (d) {
        d.setAttribute("visibility", "hidden");
      });
      tip.hidden = true;
    }
    hit.addEventListener("pointermove", function (e) {
      var r = svg.getBoundingClientRect();
      var px = ((e.clientX - r.left) / r.width) * opts.width;
      show(opts.index(px));
    });
    hit.addEventListener("pointerleave", hide);
    hit.addEventListener("blur", hide);
    hit.addEventListener("focus", function () {
      show(current < 0 ? opts.n - 1 : current);
    });
    hit.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
      e.preventDefault();
      var step = opts.keyStep || 1;
      var i = current < 0 ? opts.n - 1 : current + (e.key === "ArrowRight" ? step : -step);
      show(Math.max(0, Math.min(opts.n - 1, i)));
    });
  }

  function renderCapture(host) {
    var d = DATA.capture;
    var n = d.capture.length;
    var W = Math.max(320, host.clientWidth);
    var narrow = W < 560;
    var M = { left: narrow ? 58 : 70, right: narrow ? 62 : 74, top: 26, bottom: 30 };
    var H = narrow ? 280 : 360;
    var plotB = H - M.bottom;
    legend(host, [
      { name: t("capture"), color: C.capture },
      { name: t("spread"), color: C.spread },
    ]);
    var svg = el("svg", { viewBox: "0 0 " + W + " " + H, width: "100%", role: "img" });
    svg.setAttribute("aria-label", t("capture") + " / " + t("spread"));
    var x = function (i) {
      return M.left + (i / (n - 1)) * (W - M.left - M.right);
    };
    var axes = [
      { key: "capture", values: d.capture, max: 140, color: C.capture, side: "left" },
      { key: "spread", values: d.spread, max: 450, color: C.spread, side: "right" },
    ];
    axes.forEach(function (a) {
      a.yv = function (v) {
        return M.top + (1 - v / a.max) * (plotB - M.top);
      };
      a.y = function (i) {
        return a.yv(a.values[i]);
      };
    });
    for (var v = 0; v <= 140; v += 20) {
      var gy = axes[0].yv(v);
      el("line", { x1: M.left, x2: W - M.right, y1: gy, y2: gy, stroke: v === 0 ? C.axis : C.grid, "stroke-width": 1 }, svg);
      if (!narrow || v % 40 === 0) text(svg, M.left - 8, gy + 4, pct(v), { "text-anchor": "end", "font-size": 11 });
    }
    for (var v2 = 0; v2 <= 450; v2 += 50) {
      if (narrow && v2 % 100) continue;
      text(svg, W - M.right + 8, axes[1].yv(v2) + 4, pct(v2), { "text-anchor": "start", "font-size": 11 });
    }
    axisTitle(svg, 14, M.top, plotB, t("axisCapture"), "left");
    axisTitle(svg, W - 14, M.top, plotB, t("axisSpread"), "right");
    axes.forEach(function (a) {
      var xs = [], ys = [];
      for (var i = 0; i < n; i++) {
        xs.push(x(i));
        ys.push(a.y(i));
      }
      el("path", { d: path(xs, ys), fill: "none", stroke: a.color, "stroke-width": 2, "stroke-linejoin": "round", "stroke-linecap": "round" }, svg);
    });
    for (var yr = 2018; yr <= 2026; yr++) {
      if (narrow && yr % 2) continue;
      var xi = x((yr - 2018) * 12);
      el("line", { x1: xi, x2: xi, y1: plotB, y2: plotB + 4, stroke: C.axis }, svg);
      text(svg, xi, plotB + 18, String(yr), { "text-anchor": "middle", "font-size": 11 });
    }
    host.appendChild(svg);
    crosshair(svg, host, {
      width: W,
      top: M.top,
      bottom: plotB,
      left: M.left,
      right: W - M.right,
      n: n,
      x: x,
      index: function (px) {
        return Math.max(0, Math.min(n - 1, Math.round(((px - M.left) / (W - M.left - M.right)) * (n - 1))));
      },
      label: function (i) {
        return monthLabel(monthDate(d.start, i));
      },
      series: axes.map(function (a) {
        return { name: t(a.key), color: a.color, values: a.values, y: a.y };
      }),
    });
  }

  function renderProfiles(host) {
    var d = DATA.profiles;
    var n = d.pv.length;
    var W = Math.max(320, host.clientWidth);
    var narrow = W < 560;
    var M = { left: narrow ? 62 : 74, right: narrow ? 10 : 16, top: 12, bottom: 30 };
    var H = narrow ? 260 : 320;
    var plotB = H - M.bottom;
    legend(host, [
      { name: t("pv"), color: C.pv },
      { name: t("discharge"), color: C.discharge },
      { name: t("charge"), color: C.charge },
    ]);
    var svg = el("svg", { viewBox: "0 0 " + W + " " + H, width: "100%", role: "img" });
    svg.setAttribute("aria-label", t("pv") + ", " + t("discharge") + ", " + t("charge"));
    var x = function (i) {
      return M.left + (i / (n - 1)) * (W - M.left - M.right);
    };
    var y = function (v) {
      return M.top + ((100 - v) / 200) * (plotB - M.top);
    };
    var step = narrow ? 40 : 20;
    for (var v = -100; v <= 100; v += step) {
      el("line", { x1: M.left, x2: W - M.right, y1: y(v), y2: y(v), stroke: v === 0 ? C.axis : C.grid, "stroke-width": 1 }, svg);
      text(svg, M.left - 8, y(v) + 4, pct(v), { "text-anchor": "end", "font-size": 11 });
    }
    axisTitle(svg, 14, M.top, plotB, t("axisPower"), "left");
    var series = [
      { key: "pv", values: d.pv, color: C.pv, opacity: 0.22 },
      { key: "discharge", values: d.discharge, color: C.discharge, opacity: 0.3 },
      { key: "charge", values: d.charge, color: C.charge, opacity: 0.3 },
    ];
    series.forEach(function (s) {
      var xs = [], ys = [];
      for (var i = 0; i < n; i++) {
        xs.push(x(i));
        ys.push(y(s.values[i]));
      }
      var line = path(xs, ys);
      el("path", { d: line + "L" + x(n - 1) + "," + y(0) + "L" + x(0) + "," + y(0) + "Z", fill: s.color, "fill-opacity": s.opacity, stroke: "none" }, svg);
      // Outline only where the series is active, so idle runs don't paint the zero axis.
      var edge = "";
      for (var k = 0; k < n; k++) {
        var active = s.values[k] !== 0 || (k > 0 && s.values[k - 1] !== 0) || (k < n - 1 && s.values[k + 1] !== 0);
        if (!active) continue;
        var pen = k > 0 && (s.values[k] !== 0 || s.values[k - 1] !== 0) && edge ? "L" : "M";
        edge += pen + xs[k].toFixed(1) + "," + ys[k].toFixed(1);
      }
      el("path", { d: edge, fill: "none", stroke: s.color, "stroke-width": narrow ? 1.25 : 1.5, "stroke-linejoin": "round" }, svg);
      s.y = function (i) {
        return y(s.values[i]);
      };
      s.name = t(s.key);
      s.hideZero = s.key !== "pv";
    });
    var perDay = (24 * 60) / d.stepMin;
    for (var day = 0; day <= n / perDay; day++) {
      var xi = x(Math.min(n - 1, day * perDay));
      el("line", { x1: xi, x2: xi, y1: plotB, y2: plotB + 4, stroke: C.axis }, svg);
      if (day < n / perDay && (!narrow || day % 2 === 0)) {
        text(svg, x(day * perDay + perDay / 2), plotB + 18, profileLabel(profileDate(day * perDay), false), { "text-anchor": "middle", "font-size": 11 });
      }
    }
    host.appendChild(svg);
    crosshair(svg, host, {
      width: W,
      top: M.top,
      bottom: plotB,
      left: M.left,
      right: W - M.right,
      n: n,
      keyStep: 4,
      x: x,
      index: function (px) {
        return Math.max(0, Math.min(n - 1, Math.round(((px - M.left) / (W - M.left - M.right)) * (n - 1))));
      },
      label: function (i) {
        return profileLabel(profileDate(i), true);
      },
      series: series,
    });
  }

  var charts = [
    ["deck-chart-capture", renderCapture],
    ["deck-chart-profiles", renderProfiles],
  ];
  function renderAll() {
    charts.forEach(function (c) {
      var host = document.getElementById(c[0]);
      if (!host) return;
      host.textContent = "";
      c[1](host);
    });
  }

  var lastW = 0;
  var timer;
  window.addEventListener("resize", function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var host = document.getElementById(charts[0][0]);
      if (host && host.clientWidth !== lastW) {
        lastW = host.clientWidth;
        renderAll();
      }
    }, 150);
  });
  document.addEventListener("forsyt:langchange", renderAll);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderAll);
  } else {
    renderAll();
  }
})();
